import type { AllRouteEndpoints } from "../routeTypes";

/**
 * No cache to invalidate: this endpoint is a stateless Beefree "Simple Schema" -> full JSON
 * conversion, not a mutation of server state. The empty list satisfies the mutation-adapter
 * contract while invalidating nothing.
 */
export const postEngagementEmailMessageDndEditorSimpleToFullJsonCacheKeys: AllRouteEndpoints[] = [];
